module.exports = __webpack_public_path__ + "static/media/Portrait-10228.9402aeb0.jpg";